import CaseFirstView from 'components/cases/common/CasesFirstView/'
import OverView from 'components/cases/common/Overview/'
import Interview from 'components/cases/kyosaimypage/Interview/'
import CaseStudy from 'components/home/CaseStudy'
import { firstViewItem, overviewTitle, overviewItem, issueSolutionItems, caseCTAItem } from './KyosaimypageItems'
import CaseCTA from 'components/cases/common/CaseCTA'
import FooterCTA from 'components/common/FooterCTA'

const Kyosaimypage = () => {
  return (
    <section>
      <CaseFirstView firstViewItem={firstViewItem} />
      <OverView overviewItem={overviewItem} issueSolutionItems={issueSolutionItems} overviewTitle={overviewTitle} />
      <Interview />
      <CaseCTA {...caseCTAItem} />
      <FooterCTA />
      <CaseStudy enTitle="Case study" jaTitle="事例" tagType="h2" />
    </section>
  )
}

export default Kyosaimypage
